import React from 'react';
import './TinyFooter.css';

function TinyFooter() {
  return (
    <footer className="tinyfooter">
      <div className="tinyfooter-content">
        <div className="tinyfooter-center">
          <p>© {new Date().getFullYear()} Chattitude. All rights reserved.</p>
        </div>
        {/* <div className="tinyfooter-center">
          <p>Chattitude - Conversational AI agents that sell, support, and scale with you.</p>
        </div>
        <div className="tinyfooter-right">
          <div className="social-icons">
            <a href="https://www.youtube.com/channel/UC-GJyi2t4ZZnl57jVbTcb5Q" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://x.com/chattitudeai" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <i className="fa-brands fa-x-twitter"></i>
            </a>
            <a href="https://facebook.com/chattitude" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.linkedin.com/company/chattitude" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.tiktok.com/@chattitudeai" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div> */}
      </div>
    </footer>
  );
}

export default TinyFooter;
